export const UIActionType = {
  TOGGLE_SIDEBAR: 'ui/TOGGLE_SIDEBAR',
  SET_SIDEBAR_OPEN: 'ui/SET_SIDEBAR_OPEN',
  SET_POS_FOCUS_MODE: 'ui/SET_POS_FOCUS_MODE',
  TOGGLE_POS_FOCUS_MODE: 'ui/TOGGLE_POS_FOCUS_MODE',
  SET_LOADING: 'ui/SET_LOADING',
  RESET_LOADING_KEY: 'ui/RESET_LOADING_KEY',
}

export const POS_FOCUS_MODE_LS_KEY = 'kartly_pos_focus_mode'

function readPosFocusMode(): boolean {
  try {
    return localStorage.getItem(POS_FOCUS_MODE_LS_KEY) === '1'
  } catch {
    return false
  }
}

export function persistPosFocusMode(on: boolean) {
  try {
    localStorage.setItem(POS_FOCUS_MODE_LS_KEY, on ? '1' : '0')
  } catch {
    /* ignore */
  }
}

export function createInitialUIState() {
  return {
    sidebarOpen: false,
    posFocusMode: typeof window !== 'undefined' ? readPosFocusMode() : false,
    /** @type {Record<string, boolean>} */
    loading: {},
  }
}

export function uiReducer(state, action) {
  switch (action.type) {
    case UIActionType.TOGGLE_SIDEBAR:
      return { ...state, sidebarOpen: !state.sidebarOpen }
    case UIActionType.SET_SIDEBAR_OPEN:
      return { ...state, sidebarOpen: action.payload }
    case UIActionType.SET_POS_FOCUS_MODE: {
      const posFocusMode = Boolean(action.payload)
      persistPosFocusMode(posFocusMode)
      return { ...state, posFocusMode }
    }
    case UIActionType.TOGGLE_POS_FOCUS_MODE: {
      const posFocusMode = !state.posFocusMode
      persistPosFocusMode(posFocusMode)
      return { ...state, posFocusMode }
    }
    case UIActionType.SET_LOADING: {
      const { key, value } = action.payload
      return {
        ...state,
        loading: { ...state.loading, [key]: value },
      }
    }
    case UIActionType.RESET_LOADING_KEY: {
      const key = action.payload
      const next = { ...state.loading }
      delete next[key]
      return { ...state, loading: next }
    }
    default:
      return state
  }
}
